// @core/api/endpoints/payment/list_payment_routes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentRoutesResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payment routes
 * Returns a paginated list of payment routes. Supports filtering and sorting.
 */
export async function ListPaymentRoutes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentRoutesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-routes`;
  const requestOptions = options;
  return client.get<ListPaymentRoutesResponse>(requestPath, { ...requestOptions, params });
}
